import React, { useState } from 'react';
import moment from 'moment';
import ClickOutside from 'components/ClickOutside';
import DayPicker, { DateUtils } from 'react-day-picker';
import 'react-day-picker/lib/style.css';

const DateRange = ({
  name,
  value,
  format = '',
  onChange,
  dayPickerProps = {
    initialMonth: moment().subtract(1, 'month').toDate(),
  },
  displayFormat = 'Do MMM YYYY',
  clearable = true,
  disableFuture = true,
}) => {
  const [pickerOpen, setPickerOpen] = useState(false);

  const handleDayClick = (day, modifiers = {}) => {
    if (modifiers.disabled) {
      return;
    }
    const range = DateUtils.addDayToRange(day, value);

    return onChange({ target: { name, value: range } });
  };

  const parseValue = (formattedValue) => {
    if (!formattedValue) {
      return { from: null, to: null };
    }
    const { from, to } = formattedValue;
    return {
      from: from ? moment(from, format).toDate() : null,
      to: to ? moment(to, format).toDate() : null,
    };
  };

  const displayValue = (formattedValue) => {
    const { from, to } = formattedValue || { from: null, to: null };
    return {
      from: from ? moment(from, format).format(displayFormat) : 'From',
      to: to ? moment(to, format).format(displayFormat) : 'To',
    };
  };

  const { from, to } = parseValue(value);
  const display = displayValue(value);

  const modifiers = { start: from, end: to };
  const disabledDays = disableFuture ? { after: new Date() } : {};

  return (
    <div className="DayRangePicker">
      <div
        className="DayRangePicker-display gecko-ui-material form-control"
        onClick={() => setPickerOpen(true)}
      >
        <span>{display.from}</span>
        <span className="DayRangePicker-display-seperator">
          <i className="far fa-long-arrow-right"></i>
        </span>
        <span>{display.to}</span>
        {clearable && (from || to) ? (
          <span
            className="DayRangePicker-display-clear"
            title="Clear"
            onClick={() =>
              onChange({ target: { name, value: { from: null, to: null } } })
            }
          >
            <i className="far fa-times"></i>
          </span>
        ) : null}
      </div>
      {pickerOpen ? (
        <ClickOutside onClickOutside={() => setPickerOpen(false)}>
          <DayPicker
            numberOfMonths={2}
            selectedDays={[from, { from, to }]}
            modifiers={modifiers}
            disabledDays={disabledDays}
            onDayClick={handleDayClick}
            {...dayPickerProps}
          />
        </ClickOutside>
      ) : null}
    </div>
  );
};

export default DateRange;
